/**
 * 基本信息区 Lottie 资源（本地 bundled）。
 */

import uploadCloud from '../../../../../assets/lottieJson/basicInfo/upload-cloud.json'
import sparkleStar from '../../../../../assets/lottieJson/basicInfo/sparkle-star.json'
import happyMascot from '../../../../../assets/lottieJson/basicInfo/happy-mascot.json'

/** 左侧媒体区：待上传 */
export const LOTTIE_MEDIA_UPLOAD = uploadCloud

/** 左侧媒体区：配置型（无需文件） */
export const LOTTIE_MEDIA_CONFIG = happyMascot

/** 右侧横幅：左位 */
export const LOTTIE_BANNER_LEFT = sparkleStar

/** 右侧横幅：右位（与左不同源，尺寸适中） */
export const LOTTIE_BANNER_RIGHT = happyMascot

export const LOTTIE_PLAYBACK_OPTIONS = {
  autoplay: true,
  loop: true,
}

export function buildLottieOptions(animationData) {
  return {
    ...LOTTIE_PLAYBACK_OPTIONS,
    animationData,
  }
}
